module.exports = __webpack_public_path__ + "static/media/SM-MT1-TRIAL-if-wrong.28937787.mp3";